import { render, staticRenderFns } from "./PedidoAdm.vue?vue&type=template&id=0ba4eb02&scoped=true&"
import script from "./PedidoAdm.vue?vue&type=script&lang=js&"
export * from "./PedidoAdm.vue?vue&type=script&lang=js&"
import style0 from "./PedidoAdm.vue?vue&type=style&index=0&id=0ba4eb02&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ba4eb02",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
installComponents(component, {VCard,VCardText})
